import "../../../resources/less/Admin/Licences/AddLicenceOrg.less";
import NanomonxForm from "../../components/Forms/NanomonxForm";
import TelephoneInput from "../Contact/TelephoneInput";

class AddLicenceOrg {
  constructor() {
    new NanomonxForm({
      elementName: "quote_form",
      submitClass: ".quote-form-submit",
    });
    new TelephoneInput($("input.field-telephone"));
  }
}

$(window).on("load", () => {
  new AddLicenceOrg();
});
